export default function init() {
	// Turn off in IE 11. There was a console error - it seems array.from is the issue and the polyfill was causing issues with uglify.
	// @ts-ignore
	if (window.document.documentMode) {
		return;
	}
	
	//@ts-ignore
	var Animate = require('animate.js');

	const triggerAnimations = (selector: string, offset: number = 0.2) => {
		let elements = document.querySelectorAll(selector);
		for (let index = 0; index < elements.length; index++) {
			elements[index].setAttribute('data-animation-classes', 'visible');	
		}
		let animate = new Animate({
			offset: [offset],
			target: selector
		});
		animate.init();
	}

	triggerAnimations('.homepageMasthead');
	triggerAnimations('.intro');
	triggerAnimations('.statementImage', -0.75);
	triggerAnimations('.richContent');
	triggerAnimations('.callouts', -0.2);
}